import { useEffect, useState } from 'react';
import {
  mobileDatePickerMonthCount,
} from './mobileDatePicker.constants';

/**
 * Paint one month on the tap that opens the sheet, then render the rest
 * after that frame so the interaction can paint.
 * @param {boolean} isOpen
 * @returns {number}
 */
export function useDeferredMobileDateMonths(isOpen) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setExpanded(false);
      return undefined;
    }
    let secondFrame = 0;
    const firstFrame = requestAnimationFrame(() => {
      secondFrame = requestAnimationFrame(() => setExpanded(true));
    });
    return () => {
      cancelAnimationFrame(firstFrame);
      if (secondFrame) cancelAnimationFrame(secondFrame);
    };
  }, [isOpen]);

  return mobileDatePickerMonthCount(isOpen && expanded);
}
